
            const data = {"name":"glyph/24/more-vert","data":{"width":"24","height":"24","viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z\" class=\"nc-icon-wrapper\" _fill=\"#292a2f\"/>","originalColors":[{"type":"fill","color":"#292a2f"}],"stopColors":[]}}
        
                    module.exports = data
                    